export default __webpack_public_path__ + "static/planette-beige-half-0f16f3bbac68b853cd4705674f6ce736.svg";